import React from 'react';
import { Box, Typography } from '@mui/material';
import ConfirmationModal from './ConfirmationModal';

/**
 * Confirmation modal specifically for when users are editing their own roles
 * Provides clear warning about the implications of self-role modification
 */
const SelfEditConfirmationModal = ({ 
  open, 
  onClose, 
  onConfirm, 
  newRoles = [], 
  currentRoles = [],
  loading = false 
}) => {
  const formatRoleName = (roleName) => {
    return roleName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  };

  const formattedNewRoles = newRoles.map(formatRoleName);
  const formattedCurrentRoles = currentRoles.map(formatRoleName);

  return (
    <ConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="⚠️ Confirm Role Changes"
      message={
        <Box sx={{ textAlign: 'left' }}>
          <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
            You are about to modify your own project roles. This action will:
          </Typography>
          
          <Typography variant="body2" component="div" sx={{ ml: 2, mb: 2 }}>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Update your permissions in this project immediately</li>
              <li>May affect your access to certain features</li>
              <li>Refresh your current session automatically</li>
              <li>Cannot be undone without admin assistance</li>
            </ul>
          </Typography>

          <Box sx={{ mt: 2, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#d32f2f', mb: 1 }}>
              Current roles: {formattedCurrentRoles.join(', ') || 'None'}
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#2e7d32' }}>
              New roles: {formattedNewRoles.join(', ') || 'None'}
            </Typography>
          </Box>

          <Typography variant="body2" sx={{ mt: 2, fontStyle: 'italic', color: '#666' }}>
            Please ensure you understand the implications of these role changes before proceeding.
          </Typography>
        </Box>
      }
      confirmText="Update My Roles"
      cancelText="Cancel"
      confirmColor="warning"
      loading={loading}
    />
  );
};

export default SelfEditConfirmationModal;
